import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { revealedText: String }

  connect() {
    this.mask()
  }

  toggle() {
    if (this.element.dataset.redacted === "true") {
      this.reveal()
    } else {
      this.mask()
    }
  }

  mask() {
    this.element.textContent = "••••"
    this.element.dataset.redacted = "true"
  }

  reveal() {
    this.element.textContent = this.revealedTextValue
    this.element.dataset.redacted = "false"
  }
}
